module.exports = __webpack_public_path__ + "img/sage-logo-black.3a5fabe6.png";